//@ts-nocheck
import Router, { routingMixin } from "@jack-henry/web-component-router";
import { LitElement, css, html, PropertyValues } from "lit";
import { customElement, property } from "lit/decorators.js";
import "@banno/jha-wc/src/buttons/jha-button/jha-button";
import "@banno/jha-wc/src/forms/jha-form-input-base/jha-form-input";
import "@banno/jha-wc/src/forms/jha-form-select/jha-form-select";
import "@banno/jha-wc/src/forms/jha-form-row/jha-form-row";
import "@banno/jha-wc/src/jha-container/jha-container";
import "@banno/jha-wc/src/tables/jha-table-row/jha-table-row";
import "@banno/jha-wc/src/tables/jha-table-header/jha-table-header";
import "@banno/jha-wc/src/tables/jha-table-cell/jha-table-cell";
import "@banno/jha-wc/src/icons/jha-icon-view-more";
import "@banno/jha-wc/src/icons/jha-icon-plus";
import "@banno/jha-wc/src/icons/jha-icon-cards";
import "@banno/jha-wc/src/icons/jha-icon-search";
import "@banno/jha-wc/src/icons/jha-icon-lock";
import "@banno/jha-wc/src/dropdowns/jha-dropdown-toggle/jha-dropdown-toggle";
import "@banno/jha-wc/src/dropdowns/jha-dropdown-menu/jha-dropdown-menu";
import "@banno/jha-wc/src/dropdowns/jha-dropdown-menu-item/jha-dropdown-menu-item";
import "@banno/jha-wc/src/dropdowns/jha-dropdown/jha-dropdown";
import "@banno/jha-wc/src/tables/advanced/jha-advanced-table/jha-advanced-table";
import "@banno/jha-wc/src/jha-tooltip/jha-tooltip";
import "@banno/jha-wc/src/forms/jha-form-switch/jha-form-switch";
import "@jack-henry/jh-ui/components/input/input.js";
import {
  ADVANCED_TABLE_SORT_BUTTON_HEADER_STYLES_TEXT,
  applyAdvancedTableHeaderLayout,
  decryptValue,
  isEnterpriseAdminUserType,
  stripAdvancedTableRedundantTitles,
  stringComparison,
  buildAdvancedTableJhaTooltipOverflowEscapeCss,
  renderAdvancedTableEllipsisCell,
  buildAdvancedTableEllipsisColumnShadowCss,
} from "../../utils/app-utils";
import {
  fixedEncodeURIComponent,
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
} from "../../utils/jha-fetch";
import { Apis } from "../../utils/api-constants";
import { AddUserType } from "../../types/Users/AddUserType";
import { showToast } from "@banno/jha-wc/src/js/utils/toast-util.js";
import { GlobalVariables } from "../../utils/constants";
import { getErrorMessage } from "../../utils/getErrorMessage";
import { StatusConstants } from "../../utils/apiStatusConstants";
import { AppRouters } from "../../utils/app-router";
import { openJhftDialog } from "../../Components/JhftJhaDialog";
import Cookies from "js-cookie";
import "../Users/ChangePassword/ChangePasswordView";
import "../../Components/Loader";
import { jhaDropdownMenuPanelStyles, jhaDropdownMenuPanelStylesText } from "../../styles/jha-dropdown-menu-panel";
import {
  buildOnboardingHoverText,
  formatBusinessUnitForDisplay,
  formatEpochSecondsForDisplay,
  formatLastSignOnForGrid,
  formatProfileLabel,
  normalizeEpochSeconds,
} from "./usersGridHelpers";
import {
  dateTimeColumnLabel,
  EFM_TIMEZONE_GRID_TABLE_SHADOW_STYLES_TEXT,
  EFM_TIMEZONE_GRID_TABLE_STYLE,
  renderGridWithTimezoneBanner,
} from "../../utils/datetime-display";
import { shouldShowRedisLoginLockPadlock } from "../../utils/user-account-login-lock";

/** Grid columns that keep `title` on inner ellipsis markup (not the WC cell button). */
const USERS_GRID_ELLIPSIS_TITLE_COLUMN_IDS = new Set([
  "userId",
  "fullName",
  "businessUnit",
]);

/** List padlock only. Edit User keeps the richer admin tooltip. */
const SIGN_IN_LOCK_LIST_TOOLTIP =
  "Temporarily locked due to too many invalid login attempts.";

/** jha-tooltip `text` only; `\n` + injectAdvancedTableStyles pre-line for multiline (see onboarding). */
const ACCT_ENABLED_INACTIVE_TOOLTIP =
  "When off, the user account is inactive\nand cannot sign in.";
const ACCT_ENABLED_SELF_TOOLTIP = "You cannot inactivate your own account.";

@customElement("users-main-view")
export class UsersMainView extends routingMixin(LitElement) {
  static get is() {
    return "users-main-view";
  }
  constructor() {
    super();
  }
  @property({ type: Boolean })
  isReadOnlyUser = /readonly/i.test(
    decryptValue(Cookies.get("userRole") || "")
  );
  @property({ type: Array })
  columns = [
    {
      label: "USER ID",
      id: "userId",
      sortBy: true,
      valueRenderer: (val: any) => renderAdvancedTableEllipsisCell(val),
    },
    {
      label: "NAME",
      id: "fullName",
      sortBy: true,
      valueRenderer: (val: any) => renderAdvancedTableEllipsisCell(val),
    },
    {
      label: "USER PROFILE",
      id: "profileLabel",
      sortBy: true,
      valueFormatter: () => "",
    },
    {
      label: "USER ROLE",
      id: "roleLabel",
      sortBy: true,
      valueFormatter: () => "",
    },
    {
      label: dateTimeColumnLabel("LAST LOGIN"),
      id: "lastLoginSort",
      sortBy: true,
      dataType: "number",
      valueFormatter: () => "",
      valueRenderer: (val: number) =>
        val == null || val === 0
          ? "Never"
          : formatEpochSecondsForDisplay(val),
    },
    {
      label: dateTimeColumnLabel("ONBOARDING DATE"),
      id: "createDateTime",
      sortBy: true,
      dataType: "number",
      /** Suppress native button title (raw epoch seconds); hover copy is jha-tooltip only. */
      valueFormatter: () => "",
      valueRenderer: (_val: unknown, row: any) => html`
        <jha-tooltip bottom text=${row.onboardingHoverText}>
          <span style="white-space: nowrap;">
            ${formatEpochSecondsForDisplay(row.createDateTime)}
          </span>
        </jha-tooltip>
      `,
    },
    {
      label: "BUSINESS UNIT",
      id: "businessUnit",
      sortBy: true,
      valueRenderer: (val: any) =>
        renderAdvancedTableEllipsisCell(formatBusinessUnitForDisplay(val)),
    },
    {
      label: "ACCT ENABLED",
      id: "acctEnabledSort",
      sortBy: true,
      dataType: "number",
      /** Suppress native button title (0/1); switch has no title — jha-tooltip only. */
      valueFormatter: () => "",
      valueRenderer: (_val: unknown, user: any) => html`
        <jha-tooltip
          bottom
          text=${stringComparison(
        user.userId,
        decryptValue(Cookies.get("userId") || "")
      ) && stringComparison(user.status, "ACTIVE")
          ? ACCT_ENABLED_SELF_TOOLTIP
          : ACCT_ENABLED_INACTIVE_TOOLTIP}
        >
          <jha-form-switch
            ?disabled=${this.isReadOnlyUser ||
        stringComparison(
          user.userId,
          decryptValue(Cookies.get("userId") || "")
        )}
            ?checked=${stringComparison(user.status, "ACTIVE")}
            @change=${() => this.updateUserStatus(user)}
          >
          </jha-form-switch>
        </jha-tooltip>
      `,
    },
    {
      label: "",
      id: "accountLockSort",
      sortBy: true,
      dataType: "number",
      /** Suppress native button title (0/1); padlock has jha-tooltip only. */
      valueFormatter: () => "",
      valueRenderer: (_val: unknown, user: any) => {
        if (!shouldShowRedisLoginLockPadlock(user)) {
          return html`<span></span>`;
        }
        return html`
          <jha-tooltip bottom text=${SIGN_IN_LOCK_LIST_TOOLTIP}>
            <jha-icon-lock aria-label=${SIGN_IN_LOCK_LIST_TOOLTIP}></jha-icon-lock>
          </jha-tooltip>
        `;
      },
    },
    {
      label: "",
      id: "actionId",
      alignRight: true,
      /** Empty string for WC getColValueString → no native title/label on the wrapping button (value is userId). */
      valueFormatter: () => "",
      valueRenderer: (userId: string, _row: any) => html`
        <jha-dropdown>
          <jha-dropdown-toggle
            slot="toggle"
            tabindex="0"
            aria-expanded="false"
            aria-haspopup="true"
            role="button"
          >
            <jha-icon-view-more></jha-icon-view-more>
          </jha-dropdown-toggle>
          <jha-dropdown-menu>
            <jha-dropdown-menu-item
              role="link"
              @click=${() => this.onEditClick(userId)}
            >
              <a>${/readonly/i.test(decryptValue(Cookies.get("userRole") || ""))
          ? "View User"
          : "Edit User"}
              </a>
            </jha-dropdown-menu-item>
            ${/readonly/i.test(decryptValue(Cookies.get("userRole") || "")) ||
          decryptValue(Cookies.get("userId") || "") === userId
          ? ""
          : html`
                  <jha-dropdown-menu-item
                    role="link"
                    @click=${() => this.onDeleteUser(userId)}
                  >
                    <a>Delete User</a>
                  </jha-dropdown-menu-item>
                `}
          </jha-dropdown-menu>
        </jha-dropdown>
      `,
    },
  ].slice();

  /** Enterprise admins can narrow the grid by BU (client-side); options from GET_ALL_BUSINESSUNITVALUES. */
  @property({ type: Array })
  businessUnitFilterOptions = [{ value: "", name: "All business units" }];

  @property()
  selectedBusinessUnitFilter = "";

  /** When true, rows with inactive account status are omitted after load. */
  @property({ type: Boolean })
  hideInactiveUsers = false;

  @property()
  filterSearchId = "";
  @property()
  sortColumnId = "";
  @property()
  sortDirection = "";
  @property({ type: Boolean })
  apiLoading = false;
  @property()
  apiLimit = 100000;
  @property({ type: Object })
  advancedTableConfig = {
    apiControlled: false
  };
  @property()
  nextPageKey = "";
  @property({ type: Object })
  userFetchedData = {
    messageStatus: "",
    results: [],
    pageKey: "",
    totalCount: 0,
  };
  @property({ type: Number })
  pageLimit = 20;
  @property({ type: Object })
  usersData = {
    messageStatus: "",
    results: [],
    pageKey: "",
    totalCount: 0,
  };
  @property({ type: Array })
  usersDataClone = [];
  @property()
  pageTitle = "Users";
  @property({ type: Boolean })
  searchUser = false;

  static readonly styles = [jhaDropdownMenuPanelStyles, css`
    jha-table {
      width: 100%;
    }
    #tableCon {
      display: flex;
      flex-direction: column;
      padding: 24px;
      flex: 1;
      overflow: hidden;
    }
    jh-input {
      max-width: 350px;
    }
    #usersMain {
      display: flex;
      flex-direction: column;
      padding: 24px;
      flex: 1;
      min-height: 0;
      overflow: hidden;
    }
    jha-form-row {
      align-items: baseline;
      justify-content: flex-end;
      flex: 1;
    }
    jha-table-header {
      width: 20vw;
    }
    jha-card {
      margin-top: 10px;
      flex: 1;
      min-height: 0;
      overflow: hidden;
      margin-left: 0px;
      margin-right: 0px;
      padding: 5px;
    }
    #formCon {
      display: flex;
      flex-direction: row;
      gap: 15px;
      align-items: center;
      justify-content: space-between;
    }
    .inputContainer {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      flex-wrap: wrap;
      column-gap: 24px;
      row-gap: 12px;
      margin-right: 20px;
    }
    .inputContainer > * {
      flex-shrink: 0;
      align-self: center;
    }
    #noData {
      display: flex;
      justify-content: center;
    }
    .hideInactiveWrap {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      cursor: pointer;
      white-space: nowrap;
    }
    .bu-filter-select {
      min-width: 220px;
      max-width: 360px;
      align-self: center;
    }
  `];

  async connectedCallback() {
    super.connectedCallback();
    document.title = GlobalVariables.MAIN_TITLE?.concat(" >", this.pageTitle);
    const tasks: Promise<unknown>[] = [this.getAllUserList("")];
    if (this.isEnterpriseAdmin) {
      tasks.push(this.loadBusinessUnitFilterOptions());
    }
    await Promise.all(tasks);
  }

  /** True when the logged-in user may see the business unit filter (enterprise admin only). */
  get isEnterpriseAdmin(): boolean {
    return isEnterpriseAdminUserType(decryptValue(Cookies.get("userType") || ""));
  }

  /** Results after client-only inactive and BU filters (API search body unchanged). */
  get filteredRawUserResults() {
    let rows = [...(this.usersData?.results ?? [])];
    if (this.hideInactiveUsers) {
      rows = rows.filter((u) => !stringComparison(u.status, "inactive"));
    }
    if (this.isEnterpriseAdmin && this.selectedBusinessUnitFilter) {
      const sel = this.selectedBusinessUnitFilter;
      rows = rows.filter((u) => (u.businessUnit ?? "") === sel);
    }
    return rows;
  }

  /** Paging/total count for jha-advanced-table must reflect filtered rows, not only the server total. */
  get effectiveTableConfig() {
    return {
      ...this.advancedTableConfig,
      apiControlled: false,
      apiTotal: this.filteredRawUserResults.length,
    };
  }

  async loadBusinessUnitFilterOptions() {
    try {
      const res = await getRequest(Apis.GET_ALL_BUSINESSUNITVALUES);
      const vals = res?.businessUnitValues ?? [];
      const opts = vals
        .filter(
          (bu: { status?: string }) =>
            stringComparison(bu.status, "active") || bu.status == null,
        )
        .map((bu: { name: string }) => ({
          value: bu.name,
          name: bu.name,
        }))
        .sort((a: { name: string }, b: { name: string }) =>
          a.name.localeCompare(b.name),
        );
      this.businessUnitFilterOptions = [
        { value: "", name: "All business units" },
        ...opts,
      ];
    } catch {
      this.businessUnitFilterOptions = [{ value: "", name: "All business units" }];
    }
  }

  onBusinessUnitFilterChange(e: CustomEvent) {
    const v = (e.target as HTMLSelectElement)?.value ?? "";
    this.selectedBusinessUnitFilter = v;
  }

  onHideInactiveChange(e: CustomEvent) {
    const t = e.target as HTMLInputElement;
    this.hideInactiveUsers = !!t?.checked;
  }

  onAddUserClick() {
    AppRouters.go("/users/add-user/regular");
  }

  onDestUserClick() {
    AppRouters.go("/users/add-user/destination");
  }

  onEditClick(userId: string) {
    AppRouters.go(`/users/edit-user/` + fixedEncodeURIComponent(userId));
  }

  async onDeleteUser(userId: string) {
    const result = await openJhftDialog({
      variant: "danger",
      title: "Delete User",
      message: "Are you sure you want to delete this user? This action cannot be undone.",
      cancelLabel: "Cancel",
      confirmLabel: "Delete",
    });
    if (result !== "confirm") {
      return;
    }

    try {
      if (decryptValue(Cookies.get("userId") || "") === userId) {
        showToast({
          message: "You cannot delete yourself.",
          role: "danger",
          duration: GlobalVariables.TOAST_TIMEOUT,
        });
      } else {
        this.apiLoading = true;
        const getUserData = await getRequest(
          Apis.GET_USER + `/` + fixedEncodeURIComponent(userId)
        );
        if (getUserData?.messageStatus === null) {
          const response = await deleteRequest(
            Apis.DELETE_USER + `/` + fixedEncodeURIComponent(userId),
            getUserData?.eTag
          );

          if (response?.status === StatusConstants.DELETE_USER_SUCCESS_CODE) {
            this.apiLoading = false;
            showToast({
              message: `${userId} has been deleted.`,
              role: "success",
              duration: GlobalVariables.TOAST_TIMEOUT,
            });
            const deleteIndex = this.usersData.results.findIndex(
              (x) => x.userId === userId
            );
            this.usersData.results.splice(deleteIndex, 1);
          } else {
            this.apiLoading = false;
            showToast({
              message: "Something went wrong, please try again.",
              role: "danger",
              duration: GlobalVariables.TOAST_TIMEOUT,
            });
          }
        } else {
          this.apiLoading = false;
          showToast({
            message: "Something went wrong, please try again.",
            role: "danger",
            duration: GlobalVariables.TOAST_TIMEOUT,
          });
        }
      }
    } catch (error) { }
  }
  get listData() {
    return this.filteredRawUserResults.map((item) => {
      const lastRaw =
        item.lastSignOnDateTime ?? item.LastSignOnDateTime ?? "";
      const { sortEpochSec: lastLoginSort } = formatLastSignOnForGrid(lastRaw);
      const createRaw = item.createDateTime ?? item.CreateDateTime;
      const createSort = normalizeEpochSeconds(createRaw);
      const onboardingHoverText = buildOnboardingHoverText(
        item.updateDateTime ?? item.UpdateDateTime,
        item.updatedBy ?? item.UpdatedBy,
      );
      return {
        ...item,
        actionId: item.userId,
        profileLabel: formatProfileLabel(item.userType, item.userProfileType),
        roleLabel: stringComparison(item.roleType, "readwrite")
          ? "Read/Write"
          : stringComparison(item.roleType, "readonly")
            ? "Read Only"
            : "",
        lastLoginSort,
        createDateTime: createSort,
        onboardingHoverText,
        acctEnabledSort: stringComparison(item.status, "active") ? 1 : 0,
        accountLockSort: shouldShowRedisLoginLockPadlock(item) ? 1 : 0,
      };
    });
  }

  onSearchClick() {
    this.filterSearchId = this.filterSearchId.trimStart().trimEnd();
    if (this.filterSearchId.length > 0) {
      this.getAllUserList(this.filterSearchId);
    } else {
      this.getAllUserList("");
    }
  }

  onSearchIdChange(e: { target: { value: string } }) {
    this.filterSearchId = e.target.value;

    // Reset search filter when input is manually cleared
    if (this.filterSearchId.trim() === "") {
      this.getAllUserList("");
    }
  }

  onSearchKeyDown(e: KeyboardEvent) {
    if (e.key === "Enter") {
      e.preventDefault();
      this.onSearchClick();
    }
  }

  async onSearchClear() {
    this.filterSearchId = "";
    await this.getAllUserList("");
  }

  async updateUserStatus(user: any) {
    if (!this.isReadOnlyUser) {
      this.apiLoading = true;
      const userData = await getRequest(Apis.GET_USER + `/${user.userId}`);
      const request = {
        email: userData.email,
        homeDirectory: userData.homeDirectory,
        role: /readonly/i.test(userData?.role) ? "ReadOnly" : "ReadWrite",
        userType: userData.userType,
        businessUnit: userData.businessUnit,
        fullName: userData.fullName,
        note: userData.note,
        userProfileType: userData.userProfileType,
        status: userData.status == "active" ? "inactive" : "active",
        authType: userData.authType,
      };
      if (
        decryptValue(Cookies.get("userId") || "") === user.userId &&
        userData.status === "active" &&
        request.status === "inactive"
      ) {
        showToast({
          message: "You cannot inactivate yourself.",
          role: "danger",
          duration: GlobalVariables.TOAST_TIMEOUT,
        });
        this.apiLoading = false;
        return false;
      }

      const updateStatus = await putRequest<AddUserType>(
        Apis.UPDATE_USER + `/${user.userId}`,
        userData.eTag,
        request
      );

      if (updateStatus?.messageStatus === null) {
        this.apiLoading = false;
        this.getAllUserList("");
        showToast({
          message: "User status updated successfully.",
          role: "success",
          duration: GlobalVariables.TOAST_TIMEOUT,
        });
      } else if (updateStatus.details.length > 0) {
        this.apiLoading = false;
        const errMsg = getErrorMessage(updateStatus.details);
        showToast({
          message: errMsg,
          role: "danger",
          duration: GlobalVariables.TOAST_TIMEOUT,
        });
      } else {
        this.apiLoading = false;
        showToast({
          message: "Something went wrong, please try again.",
          role: "danger",
          duration: GlobalVariables.TOAST_TIMEOUT,
        });
      }
    }
  }

  renderTable() {
    return html`
      <jha-advanced-table
        style=${EFM_TIMEZONE_GRID_TABLE_STYLE}
        .tableConfig=${this.effectiveTableConfig}
        .columns=${this.columns}
        .data=${this.listData}
        .fullWidthColumns=${true}
        .pageLimit=${this.pageLimit}
        .allowPageChange=${true}
        .allowPageLimitChange=${true}
        .loading=${this.searchUser}
        .noContentMessage=${"No Data to Display"}
        @table-update=${this.handleTableUpdate}
      ></jha-advanced-table>
    `;
  }

  private handleTableUpdate() {
    requestAnimationFrame(() => this.injectAdvancedTableStyles());
  }

  private usersTablePaginationScrollSyncBound = false;

  updated(changed: PropertyValues) {
    super.updated?.(changed);
    const table = this.renderRoot.querySelector("jha-advanced-table") as HTMLElement | null;
    if (table) {
      table.toggleAttribute(
        "data-api-loading",
        this.apiLoading || this.searchUser,
      );
      table.toggleAttribute(
        "data-has-data",
        (this.filteredRawUserResults?.length ?? 0) > 0,
      );
    }
    const dataReloadFinished =
      changed.has("searchUser") && !this.searchUser;
    const clientFiltersChanged =
      changed.has("selectedBusinessUnitFilter") ||
      changed.has("hideInactiveUsers");
    requestAnimationFrame(() => {
      this.injectAdvancedTableStyles();
      this.ensureUsersTablePaginationScrollSync();
      if (dataReloadFinished) {
        this.resetUsersTableHorizontalScroll();
      }
      if (clientFiltersChanged) {
        void this.resetUsersAdvancedTablePagingAndLayout();
      }
    });
  }

  /**
   * WC keeps pageOffset when only client-filtered data/apiTotal shrinks → invalid ranges (e.g. "61-8 of 8") and header/body drift.
   * Reset page and run handleTableResize like next/prev paging.
   */
  private async resetUsersAdvancedTablePagingAndLayout() {
    const table = this.renderRoot.querySelector("jha-advanced-table") as
      | { pageOffset?: number; handleTableResize?: () => Promise<void> }
      | null;
    if (!table) {
      return;
    }
    table.pageOffset = 0;
    if (table.handleTableResize) {
      await table.handleTableResize();
    }
    this.resetUsersTableHorizontalScroll();
    this.stripRedundantTableTitles();
  }

  /** Re-apply cell bounds under fullWidthColumns (WC uses overflow:visible on custom-value cells). */
  private injectAdvancedTableStyles() {
    const table = this.renderRoot.querySelector("jha-advanced-table") as HTMLElement | null;
    const root = table?.shadowRoot;
    if (!root) return;
    const css = `
      ${ADVANCED_TABLE_SORT_BUTTON_HEADER_STYLES_TEXT}
      ${EFM_TIMEZONE_GRID_TABLE_SHADOW_STYLES_TEXT}
      ${jhaDropdownMenuPanelStylesText}
      .loading jh-progress { visibility: hidden; }
      :host([data-api-loading]) .no-content,
      :host([data-has-data]) .no-content { visibility: hidden; }
      .no-content p {
        font-size: 20px;
        font-weight: 600;
        margin: 0;
      }
      ${buildAdvancedTableJhaTooltipOverflowEscapeCss(["createDateTime", "acctEnabledSort", "accountLockSort"])}
      ${buildAdvancedTableEllipsisColumnShadowCss([
      "userId",
      "fullName",
      "businessUnit",
    ])}
      /*
       * Bottom tooltips: shift the bubble (::after) inside the table; keep the caret (::before)
       * on the WC default (right: 50%) so it stays centered on the hover target. Moving both
       * pseudos to right: 0 / left: 0 detaches the triangle from the tooltip box.
       */
      jha-table-cell#createDateTime jha-tooltip[bottom]::after {
        right: auto;
        left: 0;
        transform: none;
      }
      jha-table-cell#acctEnabledSort jha-tooltip[bottom]::after,
      jha-table-cell#accountLockSort jha-tooltip[bottom]::after {
        left: auto;
        right: 0;
        transform: none;
      }
      /* jha-tooltip default max-width 160px clips long copy; pre-line honors \\n from text attr */
      jha-table-cell#createDateTime jha-tooltip[bottom]::after,
      jha-table-cell#acctEnabledSort jha-tooltip[bottom]::after,
      jha-table-cell#accountLockSort jha-tooltip[bottom]::after {
        white-space: pre-line;
        max-width: 300px;
      }
      jha-table-cell#accountLockSort jha-icon-lock {
        --jha-icon-color: var(--jha-text-neutral, #5c6773);
        width: 20px;
        height: 20px;
      }
      jha-table-row[expand-all-columns] jha-table-cell#createDateTime span {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      jha-table-row[expand-all-columns] jha-table-cell#acctEnabledSort:not([checkbox]) {
        max-width: 140px;
        min-width: 0;
      }
      jha-table-row[expand-all-columns] jha-table-cell#acctEnabledSort jha-form-switch {
        max-width: 100%;
      }
      jha-table-row[expand-all-columns] jha-table-cell#userId:not([checkbox]),
      jha-table-row[expand-all-columns] jha-table-cell#fullName:not([checkbox]),
      jha-table-row[expand-all-columns] jha-table-cell#profileLabel:not([checkbox]),
      jha-table-row[expand-all-columns] jha-table-cell#roleLabel:not([checkbox]),
      jha-table-row[expand-all-columns] jha-table-cell#lastLoginSort:not([checkbox]),
      jha-table-row[expand-all-columns] jha-table-cell#businessUnit:not([checkbox]) {
        max-width: var(--jha-advanced-table-column-max-width, 250px);
        min-width: 0;
        overflow: hidden !important;
      }
      jha-table-row[expand-all-columns] jha-table-cell#createDateTime:not([checkbox]) {
        max-width: var(--jha-advanced-table-column-max-width, 250px);
        min-width: 0;
      }
      jha-table-row[expand-all-columns] jha-table-cell#userId button[data-button],
      jha-table-row[expand-all-columns] jha-table-cell#fullName button[data-button],
      jha-table-row[expand-all-columns] jha-table-cell#profileLabel button[data-button],
      jha-table-row[expand-all-columns] jha-table-cell#roleLabel button[data-button],
      jha-table-row[expand-all-columns] jha-table-cell#lastLoginSort button[data-button],
      jha-table-row[expand-all-columns] jha-table-cell#businessUnit button[data-button] {
        overflow: hidden !important;
        max-width: 100%;
        min-width: 0;
      }
      div.table-wrapper {
        overflow-x: hidden;
      }
    `;
    let style = root.querySelector("style[data-acme-1180]") as HTMLStyleElement | null;
    if (!style) {
      style = document.createElement("style");
      style.setAttribute("data-acme-1180", "");
      root.appendChild(style);
    }
    style.textContent = css;
    applyAdvancedTableHeaderLayout(root);
    this.stripRedundantTableTitles();
  }

  /**
   * jha-advanced-table sets title on button[data-button] from getColValueString; with dataType
   * "number" that ignores valueFormatter and shows 0/1 or epoch. Ellipsis columns keep title on inner divs only.
   */
  private stripRedundantTableTitles() {
    const table = this.renderRoot.querySelector("jha-advanced-table");
    const root = table?.shadowRoot;
    if (!root) {
      return;
    }
    stripAdvancedTableRedundantTitles(root, USERS_GRID_ELLIPSIS_TITLE_COLUMN_IDS);
    root.querySelectorAll("jha-table-cell.button-cell button[data-button]").forEach((btn) => {
      btn.removeAttribute("arial-label");
    });
  }

  /** Clears body horizontal scroll so sticky header margin stays in sync (WC only resets scrollTop on page change). */
  private resetUsersTableHorizontalScroll() {
    const table = this.renderRoot.querySelector("jha-advanced-table") as HTMLElement | null;
    const wrap = table?.shadowRoot?.querySelector(
      "div.table-wrapper",
    ) as HTMLElement | null;
    if (!wrap) {
      return;
    }
    if (wrap.scrollLeft !== 0) {
      wrap.scrollLeft = 0;
    }
  }

  /**
   * Next/prev call handleTableResize in jha-advanced-table; jumpToPage does not, so header/body column widths drift.
   * handleTableResize is public on the WC and realigns layout after pageOffset updates.
   */
  private async syncUsersAdvancedTableAfterPaging() {
    const table = this.renderRoot.querySelector("jha-advanced-table") as
      | { handleTableResize?: () => Promise<void> }
      | null;
    if (table?.handleTableResize) {
      await table.handleTableResize();
    }
    this.resetUsersTableHorizontalScroll();
    this.stripRedundantTableTitles();
  }

  private ensureUsersTablePaginationScrollSync() {
    if (this.usersTablePaginationScrollSyncBound) {
      return;
    }
    const table = this.renderRoot.querySelector("jha-advanced-table") as
      | HTMLElement
      | null;
    const root = table?.shadowRoot;
    if (!table || !root) {
      return;
    }
    this.usersTablePaginationScrollSyncBound = true;
    const scrollOnly = () => {
      requestAnimationFrame(() => {
        this.resetUsersTableHorizontalScroll();
        this.stripRedundantTableTitles();
      });
    };
    table.addEventListener("pagination-backward", scrollOnly);
    table.addEventListener("pagination-forward", scrollOnly);
    table.addEventListener("page-limit-change", () => {
      void this.syncUsersAdvancedTableAfterPaging();
    });
    root.addEventListener(
      "click",
      (e: Event) => {
        const popover = root.querySelector("jha-popover#pager");
        if (!popover || !e.composedPath().includes(popover)) {
          return;
        }
        const target = e.target as HTMLElement | null;
        if (!target || target.tagName !== "BUTTON") {
          return;
        }
        const openSlot = popover.querySelector("[slot=\"button\"]");
        if (
          openSlot &&
          (target === openSlot || openSlot.contains(target))
        ) {
          return;
        }
        void this.syncUsersAdvancedTableAfterPaging();
      },
      false,
    );
  }

  async getAllUserList(searchId: string) {
    this.apiLoading = true;
    this.searchUser = true;
    try {
      const reqParams = {
        userId: searchId,
      };
      const getUsers = await postRequest<{ userId: string }>(
        Apis.USER_SEARCH,
        reqParams
      );
      if (!getUsers) {
        return;
      }
      if (getUsers?.messageStatus === null) {
        this.usersData = { ...getUsers };
        this.usersDataClone = getUsers?.results;
        this.advancedTableConfig.apiTotal = getUsers?.totalCount;
        this.nextPageKey = getUsers?.pageKey;
      } else if (getUsers?.status === StatusConstants.NOT_FOUND_USER_CODE) {
        this.usersData = {
          messageStatus: "",
          results: [],
          pageKey: "",
          totalCount: 0,
        };
      } else if (getUsers?.details?.length > 0) {
        const errMsg = getErrorMessage(getUsers?.details);
        showToast({
          message: errMsg,
          role: "danger",
          duration: GlobalVariables.TOAST_TIMEOUT,
        });
      } else {
        showToast({
          message: "Something went wrong, please try again.",
          role: "danger",
          duration: GlobalVariables.TOAST_TIMEOUT,
        });
      }
    } catch {
    } finally {
      this.searchUser = false;
      this.apiLoading = false;
    }
  }

  render() {
    return html`
      <slot>
        ${this.apiLoading ? html`<circle-loader></circle-loader>` : undefined}
        <div id="usersMain">
          <div id="formCon">
            <h1>Users</h1>
            <div class="inputContainer">
              <jha-tooltip bottom text="Hide users whose account status is inactive.">
                <label class="hideInactiveWrap">
                  <span>Hide inactive</span>
                  <jha-form-switch
                    data-auto-id="hideInactiveUsersSwitch"
                    ?checked=${this.hideInactiveUsers}
                    @change=${this.onHideInactiveChange}
                  ></jha-form-switch>
                </label>
              </jha-tooltip>
              ${this.isEnterpriseAdmin
        ? html`
                    <jha-tooltip
                      bottom
                      text="Filter the grid by business unit. All business units shows every user."
                    >
                      <jha-form-select
                        class="bu-filter-select"
                        outline
                        .options=${this.businessUnitFilterOptions}
                        lableKey="name"
                        valueKey="value"
                        .value=${this.selectedBusinessUnitFilter}
                        emptyOptionLabel=""
                        data-auto-id="usersBusinessUnitFilter"
                        @change=${this.onBusinessUnitFilterChange}
                      ></jha-form-select>
                    </jha-tooltip>
                  `
        : ""}
              <jha-tooltip bottom text="Search by User ID">
                <jh-input
                  show-clear-button
                  data-auto-id="searchIdInput"
                  .placeholder=${"Search"}
                  @jh-clear=${this.onSearchClear}
                  .value=${this.filterSearchId}
                  @input=${this.onSearchIdChange}
                  @keydown=${this.onSearchKeyDown}
                  maxlength="256"
                >
                </jh-input>
              </jha-tooltip>
              <jha-button sync type="button" icon @click=${this.onSearchClick}>
                <jha-icon-search></jha-icon-search>
              </jha-button>
              <jha-dropdown
                data-auto-id="addUserDropdown"
                ?disabled=${/readonly/i.test(
          decryptValue(Cookies.get("userRole") || "")
        )}
              >
                <jha-dropdown-toggle
                  data-auto-id="addUserDropdownToggle"
                  slot="toggle"
                  tabindex="0"
                  aria-expanded="false"
                  aria-haspopup="true"
                  role="button"
                  style="width:min-content !important;"
                >
                  <jha-tooltip
                    left
                    text="Click to select and add Regular user or Destination user."
                  >
                    <jha-button
                      data-auto-id="addUserBtn"
                      type="button"
                      large
                      sync
                      ?disabled=${/readonly/i.test(
          decryptValue(Cookies.get("userRole") || "")
        )}
                    >
                      <jha-icon-plus slot="icon-left"></jha-icon-plus>Add User
                    </jha-button>
                  </jha-tooltip>
                </jha-dropdown-toggle>
                <jha-dropdown-menu>
                  <jha-dropdown-menu-item
                    data-auto-id="addUserRegDropdownItem"
                    role="link"
                    @click=${this.onAddUserClick}
                  >
                    <a>Regular</a>
                  </jha-dropdown-menu-item>
                  <jha-dropdown-menu-item
                    data-auto-id="addUserDestDropdownItem"
                    role="link"
                    @click=${this.onDestUserClick}
                  >
                    <a>Destination</a>
                  </jha-dropdown-menu-item>
                </jha-dropdown-menu>
              </jha-dropdown>
            </div>
          </div>
          <jha-card
            >${renderGridWithTimezoneBanner(this.renderTable())}</jha-card
          >
        </div>
      </slot>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "users-main-view": UsersMainView;
  }
}
